<template>
  <div class="common-pagination">
    <span>
      共 {{ total }} 条记录 第{{ total==0?0:page }}/{{ Math.ceil(total / pageSize) }}页
    </span>
    <a-pagination
        :total="total"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="['1', '20', '50', '100']"
        :current="page"
        :pageSize.sync="pageSize"
        @change="$listeners.pageChange"
        @showSizeChange="$listeners.pageSizeChange"
    ></a-pagination>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      pageSize: 20,
    };
  },
};
</script>

<style scoped lang='scss'>
.common-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 1.5rem;
}
</style>
